import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-40" }
const _hoisted_2 = { class: "mx-auto max-w-screen-md" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_5 = {
  key: 1,
  class: "text-sm text-red-600"
}
const _hoisted_6 = {
  key: 2,
  class: "bg-white border border-gray-200 shadow-sm p-6"
}
const _hoisted_7 = { class: "text-3xl font-semibold text-gray-900" }
const _hoisted_8 = { class: "text-sm text-gray-600 mt-2" }
const _hoisted_9 = { class: "text-gray-700 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "text-sm font-medium text-primary",
          to: "/dashboard"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Back to Dashboard ")
          ])),
          _: 1
        })
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading announcement... "))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.announcement?.title), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatDate(_ctx.announcement?.createdAt)), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.announcement?.body), 1)
            ]))
    ])
  ]))
}